import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M2_Summary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary of Module 2"
    videos={[]} // No specific videos for the summary
    takeaways={[
      {
        text: "If you limit your capabilities to being an average or below-average student, focus on learning the theory of functions and storage classes, along with basic coding skills, such as taking inputs for strings and arrays and writing code for standard string operations.",
      },
      {
        text: "If you want good marks from this module, you need to practice the coding part of arrays and strings, which includes using for loops and if statements. (The questions in the exam won't be very tough, but you will need to spend some time thinking about them.)",
      },
    ]}
    questions={[]} // No specific questions for the summary
    exampleVideos={[]} // No extra example videos for now
  />
);
}

export default OOPS_M2_Summary;
